import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { ApiOutlet, ApiRegister } from '@vend/types'
import { SelectRegisterModalView } from '../../select-register/selectRegisterModal'
import { useRegisterManager, useUserManager } from '../../../ng-compat/hooks'

interface SelectRegisterProps {
  onClose: () => void
  dismissable: boolean
}

interface RegistersByOutlet {
  outlet: ApiOutlet
  registers: ApiRegister[]
}

export const SelectRegister: FunctionComponent<SelectRegisterProps> = ({
  onClose,
  dismissable,
}) => {
  const [registersByOutlet, setRegistersByOutlet] = useState<
    RegistersByOutlet[]
  >([])
  const [selectedOutletIndex, setSelectedOutletIndex] = useState<number>(0)
  const userManager = useUserManager()
  const registerManager = useRegisterManager()

  const activeUser = userManager.getLoggedInUser()
  const activeOutlet = registerManager.getActiveOutlet()
  const selectedRegister = registerManager.getActiveRegister()

  useEffect(() => {
    const handleRegisters = async () => {
      // Have to use a type assertion here as the types in registerManager
      // are what we shall call "interesting"
      const registers = (await registerManager.getAllRegistersByOutlet({
        restrictedOutlets: activeUser.restricted_outlet_ids || undefined,
      })) as RegistersByOutlet[]
      setRegistersByOutlet(registers)

      const selectedOutletIndex = registers.findIndex(
        registerByOutlet => registerByOutlet.outlet.id === activeOutlet?.id
      )
      setSelectedOutletIndex(
        selectedOutletIndex !== -1 ? selectedOutletIndex : 0
      )
    }

    handleRegisters()
  }, [activeOutlet?.id, activeUser.restricted_outlet_ids, registerManager])

  const onSelectRegister = useCallback(
    (register: ApiRegister, outlet: ApiOutlet) => {
      if (selectedRegister && selectedRegister.id !== register.id) {
        registerManager.setActiveRegister(register, outlet)
      }
      onClose()
    },
    [onClose, registerManager, selectedRegister]
  )

  return (
    <SelectRegisterModalView
      onClose={onClose}
      size="large"
      dismissable={dismissable}
      registersByOutlet={registersByOutlet}
      selectedOutletIndex={selectedOutletIndex}
      selectedRegister={selectedRegister}
      onSelectRegister={onSelectRegister}
    />
  )
}
